export default function NavBar() {
  return (
    <nav className="nav">
      <a href="/" className="site-title">
        <img 
          src="/favicon.ico" 
          alt="Sublime Applications Logo" 
          className="logo"
        />
        Sublime Applications
      </a> 
      <ul>
        <li>
          <a href="/about"> About Us</a>
        </li>
        <li>
          <a href="/contact"> Contact Us</a>
        </li>
        <li>  
          <a href="/appointment"> Book Appointment</a>
        </li>
      </ul>
    </nav>
  );
}
